import React from 'react'
import Image from '../../Image'
import { medias } from '../../../config/Resources'
import { Button } from '@mui/material'
import { guidancePageContant } from '../../../config/pageContent'
import { East } from '@mui/icons-material'
import Text from '../../Text'
import classNames from 'classnames'

interface Props {
    Title?: string | JSX.Element | JSX.Element[],
    Description?: string | JSX.Element | JSX.Element[],
    ButnText?: string,
    MainImage?: string,
    isTitle?: boolean,
    DescTopText?: string | JSX.Element | JSX.Element[],
    wrapperClassName?: string,
    TitleClassname?: string,
    dataContainerClassName? : string,
    btnClassName?:string,
    mainwrapperClassName?: string;
    containerClasses? : string;
}

const Face3 = ({btnClassName, containerClasses   ,  Title = guidancePageContant.Face3.whatCounselling, Description = <>
    <Text className='mt-[44.05px] leading-9 opacity-[69%] text-lg'>
        {guidancePageContant.Face3.indianInstitute}
    </Text>
    <Text className='mt-[44.05px] leading-9 opacity-[69%] text-lg'>
        {guidancePageContant.Face3.establishin}
    </Text>

</>,mainwrapperClassName, ButnText = guidancePageContant.Face3.chatWithCounsellerNow, MainImage, DescTopText = guidancePageContant.Face3.howCareerGuidance, isTitle = true, TitleClassname, wrapperClassName , dataContainerClassName}: Props) => {
    return (
        <div className={classNames(containerClasses,'bg-[#F3F6FF]')}>
            <div className={classNames( mainwrapperClassName,'bg-[#F3F6FF]  pb-[172px] relative -top-[7.3rem] pl-[155px] pr-[199.8px]  pt-[219.99px] ')}>

                <Text className={classNames(TitleClassname, 'text-[22px] font-bold opacity-50 ml-auto w-2/6 mr-14 text-center')}>
                    {Title}
                </Text>
                <div className={classNames('flex mt-[23px]', wrapperClassName)}>
                    <div className={classNames( dataContainerClassName,'w-1/2')}>
                        {isTitle && <Text className='text-[67px] font-extrabold'>
                            {DescTopText}
                        </Text>}
                        {Description}
                        <Button
                            variant='contained'
                            className={classNames('bg-[#2771E6] !rounded-2xl !text-lg gap-4 !mt-4 !capitalize  !p-6', btnClassName)}
                        >
                            {ButnText}<East />
                        </Button>
                    </div>
                    <div className='flex flex-col items-center w-1/2 gap-[23px]'>
                        <Image className='ml-auto' src={MainImage || medias.images.guidance.Face3.face3main} alt="" />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Face3